import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const HamburgerButton = ({ isOpen, onClick }) => {
  return (
    <button
      type="button"
      className={`hamburger hamburger--spring ${(isOpen ? 'is-active' : '')}`}
      onClick={onClick}
    >
      <span className="hamburger-box">
        <span className="hamburger-inner" />
      </span>
    </button>
  );
};

propTypes.propTypes = propTypes;

export default HamburgerButton;



// WEBPACK FOOTER //
// ./src/components/buttons/HamburgerButton.js